import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import RegAssociationDivisionFormAccordionSelect from './RegAssociationDivisionFormAccordionSelect';

const PaymentPlanAssignRegistrationFormsModal = ({
  isOpen,
  onClose,
  onConfirm,
  pkRegAssociation,
  regAssociationDivisionForms
}) => {
  const [formState, setFormState] = useState({
    regAssociationDivisionForms: []
  });

  useEffect(() => {
    if (isOpen) {
      setFormState({regAssociationDivisionForms: regAssociationDivisionForms || []});
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        onSubmit: () => {
          onConfirm(formState.regAssociationDivisionForms);
        },
        onCancel: onClose,
        submitTitle: 'Confirm'
      }}
      isNewModalStyle
      isOpen={isOpen}
      onClose={onClose}
      size={800}
      title="Assign registrations"
    >
      <AppStack style={{ gap: 16 }}>
        <AppText
          style={{
            fontSize: 14,
            color: '#666',
            textAlign: 'center',
            fontStyle: 'italic'
          }}
        >
          Select the registrations to assign to this payment plan.
        </AppText>

        <RegAssociationDivisionFormAccordionSelect
          onChange={(divisionForms) =>
            setFormState({ regAssociationDivisionForms: divisionForms })
          }
          pkRegAssociation={pkRegAssociation}
          pkRegAssociationDivisionForms={formState.regAssociationDivisionForms.map(
            (df) => df.pkRegAssociationDivisionForm
          )}
        />
      </AppStack>
    </ResponsiveModal>
  );
};

PaymentPlanAssignRegistrationFormsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  pkRegAssociation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  regAssociationDivisionForms: PropTypes.array
};

export default PaymentPlanAssignRegistrationFormsModal;
